<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span v-html="highlightedText" />
</template>

<script>
  export default {
    name: 'TextHighlight',
    props: {
      highlightClass: {
        type: String,
        default: 'highlighted-text',
      },
      queryString: {
        type: String,
        default: undefined,
      },
    },
    computed: {
      highlightedText() {
        if ( !this.$slots.default ) return ''

        const slotContent = this.$slots.default()

        if ( !slotContent || slotContent.length === 0 ) return ''

        let text = ''
        const firstSlot = slotContent[0]

        if ( typeof firstSlot === 'string' ) {
          text = firstSlot
        } else if ( firstSlot.children ) {
          // Handle text nodes
          if ( typeof firstSlot.children === 'string' ) {
            text = firstSlot.children
          } else if ( Array.isArray(firstSlot.children) ) {
            text = firstSlot.children
              .map((child) => {
                if (typeof child === 'string') return child
                if (child.text) return child.text
                if (child.children && typeof child.children === 'string') return child.children
                return ''
              })
              .join('')
          }
        } else if (firstSlot.text) {
          text = firstSlot.text
        }

        if ( !text || !this.queryString ) {
          return text || ''
        }

        // Escape special regex characters in queryString
        const escapedQuery = this.queryString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const regex = new RegExp(`(${escapedQuery})`, 'gi')
        return text.replace(regex, `<span class='${this.highlightClass}'>$1</span>`)
      },
    },
  }
</script>
